import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { FormAlertModule } from '@core/form-alert/form-alert.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DemoMaterialModule } from '@shared/material-module';
import { ConfirmModalModule } from '@shared/modals/confirm-modal/confirm-modal.module';
import { DocumentModalModule } from '@shared/modals/document-modal/document-modal.module';
import { VersionModalModule } from '@shared/modals/version-modal/version-modal.module';
import { TableModule } from '@shared/table/table.module';
import { NgxSpinnerModule } from 'ngx-spinner';
import { SumePipesModule } from 'src/app/pipes/sume-pipes.module';
import { BreadcrumbsComponent } from './components/breadcrumbs/breadcrumbs.component';
import { CardButtonsComponent } from './components/card-buttons/card-buttons.component';
import { CardHeaderComponent } from './components/card-header/card-header.component';
import { FiltroTabelaComponent } from './components/filtro-tabela/filtro-tabela.component';
import { HelpTooltipComponent } from './components/help-tooltip/help-tooltip.component';
import { HtmlContentCardComponent } from './components/html-content-card/html-content-card.component';
import { IconButtonModule } from './components/icon-button/icon-button.module';
import { ListItemsModule } from './components/list-items/list-items.module';
import { NewCardButtonsComponent } from './components/new-card-buttons/new-card-buttons.component';
import { ProcessoGuiaComponent } from './components/processo-guia/processo-guia.component';
import { ContainerCardComponent } from './container-card/container-card.component';
import { ContainerPageComponent } from './container-page/container-page.component';
import { ContainerTableComponent } from './container-table/container-table.component';
import { DataTableComponent } from './containers/data-table/data-table.component';
import { HomeFooterComponent } from './footer/home-footer.component';
import { HomeHeaderComponent } from './header/home-header.component';
import { QuadroComponent } from './quadro/quadro.component';
import { HomeSidebarComponent } from './sidebar/home-sidebar.component';
import { TabComponent } from './tabbed-form/tab/tab.component';
import { TabbedFormComponent } from './tabbed-form/tabbed-form.component';

const components = [
    ContainerCardComponent,
    FiltroTabelaComponent,
    HelpTooltipComponent,
    ContainerPageComponent,
    HomeFooterComponent,
    HomeHeaderComponent,
    HomeSidebarComponent,
    DataTableComponent,
    ContainerTableComponent,
    QuadroComponent,
    BreadcrumbsComponent,
    CardHeaderComponent,
    TabbedFormComponent,
    TabComponent,
    CardButtonsComponent,
    HtmlContentCardComponent,
    ProcessoGuiaComponent,
    NewCardButtonsComponent,
];

@NgModule({
    declarations: components,
    exports: components.concat([
        FormAlertModule,
        ConfirmModalModule,
        NgxSpinnerModule,
        ReactiveFormsModule,
        NgbModule,
        TableModule,
        IconButtonModule,
        ListItemsModule,
        DemoMaterialModule,
    ]),
    imports: [
        CommonModule,
        RouterModule,
        NgbModule,
        MatTooltipModule,
        VersionModalModule,
        SumePipesModule,
        NgxSpinnerModule,
        DemoMaterialModule,
        ReactiveFormsModule,
        FormAlertModule,
        ConfirmModalModule,
        DocumentModalModule,
    ],
})

// TODO: Alterar o nome do modulo para SumeLayoutModule e verificar os erros que vão aparecer
export class LayoutModule {}
